export default {
  edit_profile: "Редактирование профиля",
  my_account: "Мой аккаунт",
  balance: "Баланс",
  available_for_withdrawal: "Доступно для вывода",
  amount_in_hold: "Сумма в Hold",
  latest_news: "Последние новости",
  more_news: "Все новости"
};
